define ['./notificationsTable.scss'], () ->
  ($rootScope, RentappService, $http, RENTAPPLICATION_API_URL, $timeout, $cacheFactory, Flash) ->
    restrict: "E"
    template: require("./notificationsTable.jade")
    scope:
      displayed: "="

    link: (scope, element, attrs) ->
      scope.search_term = ""
      scope.resent = {}

      scope.search = () ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        $http.get "#{RENTAPPLICATION_API_URL}/api/v1/notification/",
          params:
            limit: 25
            offset: 0
            search: scope.search_term.trim()
        .then (response) ->
          scope.displayed = response.data.objects
          scope.is_loading = false

      scope.resend = (row) ->
        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/notification/#{row.id}/resend/"
        .then (response) ->
          scope.resent[row.id] = true
          Flash.create("success", "Email resent!", 3000)
        .catch (error) ->
          Flash.create("danger", "Error occurred while resending email.", 3000)
          #scope.error = error

      $rootScope.$on 'paginate', (event, data) ->
        scope.is_loading = true
        $http.get "#{RENTAPPLICATION_API_URL}/api/v1/notification/",
          params:
            limit: 25
            offset: data.offset
            search: scope.search_term.trim()
        .then (response) ->
          scope.displayed = response.data.objects
          scope.is_loading = false



// WEBPACK FOOTER //
// ./directives/notificationsTable/notificationsTable.coffee